import Vue from 'vue'
import store from './store'
import router from './router'
import App from './components/App'
import AOS from 'aos';
import 'aos/dist/aos.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import tinymce from 'vue-tinymce-editor'
import cookies from './cookie'

Vue.prototype.cookies = cookies;
Vue.use(ElementUI)
Vue.use(tinymce);

router.beforeEach((routeTo, from, next) => {
  const authRequired = routeTo.matched.some((route) => route.meta.authRequired)
  if (authRequired) {
    if (!cookies.getCookie('token')) {
      next('/admin/login');
      return;
    } else {
      next();
    }
  } else {
    next();
    return;
  }
});
new Vue({
  created() {
    AOS.init({});
  },
  router,
  store,
  template: '<App/>',
  components: { App }
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js